import { from } from 'rxjs'
import { mergeMap, pluck } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import * as trackActionTypes from '../../../constants/actionTypes/tracks'
import * as trackActions from '../../../actions/tracks/trackActions'
import roomActions from '../../../actions/room'

const checkAudioAndVideoState$ = (actions$, state, { actions }) =>
  actions$.pipe(
    ofType(trackActionTypes.SET_TRACK_STATUS),
    pluck('payload'),
    mergeMap(track => {

      const dispatch = []

      if (state.value.docs.uiDoc) {

        const {
          mute = [],
          videoDisplay = []
        } = state.value.docs.uiDoc.data

        switch (track.kind) {

          case 'video':
            if (videoDisplay.length > 0) dispatch.push(roomActions.updateVideoDisplay(videoDisplay))
            break
          case 'audio':
            if (mute.length > 0) dispatch.push(trackActions.updateAudioMute(mute))
            break
          default:
            break

        }

      }

      return from(dispatch)

    })
  )

export default checkAudioAndVideoState$
